import React from 'react'
import ButtonToolbar from '../../common/components/ButtonToolbar'
import './TablePageButtonToolBar.scss'

export default function TablePageButtonToolBar ({ className, ...rest }) {
  return (
    <ButtonToolbar {...rest} className={'table-page-button-tool-bar' + (className ? ' ' + className : '')}/>
  )
}